// import merge from 'lodash/merge'
import enConfig from 'tdesign-vue-next/es/locale/en_US'
import zhConfig from 'tdesign-vue-next/es/locale/zh_CN'
import zhTWConfig from 'tdesign-vue-next/es/locale/zh_TW'
import { LOCALE } from './localeSettings'
import { getGlobalLocale } from '@/locales/setup'

export const getTDesignLocale = () => {
  let customConfig:any = {}
  let localeLanguage = getGlobalLocale()
  switch(localeLanguage){
    case LOCALE.EN_US:
      customConfig = Object.assign(enConfig, {
        select: {
          placeholder: 'Please select',
          empty: 'Empty data'
        },
        treeSelect: {
            placeholder: 'Please select',
            empty: 'Empty data'
        },
        cascader: {
            placeholder: 'Please select',
            empty: 'Empty data'
        },
        input: {
            placeholder: 'Please enter'
        },
        datePicker: {
            ...enConfig.datePicker,
            placeholder: {
                ...enConfig.datePicker.placeholder,
                date: ['Start Date', 'End Date']
            }
        }
      })
      break
    case LOCALE.ZH_CN:
      customConfig = zhConfig
      break
    case LOCALE.ZH_HK:
      customConfig = zhTWConfig
      break
    case LOCALE.ES:
      customConfig = Object.assign(JSON.parse(JSON.stringify(enConfig)), {
        select: {
            placeholder: 'Seleccione',
            empty: 'Sin datos'
        },
        treeSelect: {
            placeholder: 'Seleccione',
            empty: 'Sin datos'
        },
        cascader: {
            placeholder: 'Seleccione',
            empty: 'Sin datos'
        },
        input: {
            placeholder: 'Por favor, ingrese'
        },
        datePicker: {
            ...enConfig.datePicker,
            placeholder: {
                ...enConfig.datePicker.placeholder,
                date: ['Fecha de inicio', 'Fecha de fin']
            },
            months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            weekdays: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom']
        },
        pagination: {
            ...enConfig.pagination,
            itemsPerPage: "{size} por página",
            jumpTo: "Ir a página",
            total: "{total} elementos"
        }
      })
      break
    case LOCALE.FR:
      customConfig = Object.assign(JSON.parse(JSON.stringify(enConfig)), {
        select: {
            placeholder: 'Veuillez sélectionner',
            empty: 'Aucune donnée'
        },
        treeSelect: {
            placeholder: 'Veuillez sélectionner',
            empty: 'Aucune donnée'
        },
        cascader: {
            placeholder: 'Veuillez sélectionner',
            empty: 'Aucune donnée'
        },
        input: {
            placeholder: 'Veuillez entrer'
        },
        datePicker: {
            ...enConfig.datePicker,
            placeholder: {
                ...enConfig.datePicker.placeholder,
                date: ['Date de début', 'Date de fin']
            },
            months: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
            weekdays: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.']
        },
        pagination: {
            ...enConfig.pagination,
            itemsPerPage: "{size} par page",
            jumpTo: "Aller à",
            total: "{total} éléments"
        }
      })
      break
    case LOCALE.DE:
      customConfig = Object.assign(JSON.parse(JSON.stringify(enConfig)), {
        select: {
            placeholder: 'Bitte wählen',
            empty: 'Keine daten'
        },
        treeSelect: {
            placeholder: 'Bitte wählen',
            empty: 'Keine daten'
        },
        cascader: {
            placeholder: 'Bitte wählen',
            empty: 'Keine daten'
        },
        input: {
            placeholder: 'Bitte eingeben'
        },
        datePicker: {
            ...enConfig.datePicker,
            placeholder: {
                ...enConfig.datePicker.placeholder,
                date: ['Startdatum', 'Enddatum']
            },
            months: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
            weekdays: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So']
        },
        pagination: {
            ...enConfig.pagination,
            itemsPerPage: "{size} pro Seite",
            jumpTo: "Gehe zu",
            total: "{total} Elemente"
        }
      })
      break
    case LOCALE.NL_NL:
      customConfig = Object.assign(JSON.parse(JSON.stringify(enConfig)), {
        select: {
            placeholder: 'Selecteer alstublieft',
            empty: 'Geen gegevens'
        },
        treeSelect: {
            placeholder: 'Selecteer alstublieft',
            empty: 'Geen gegevens'
        },
        cascader: {
            placeholder: 'Selecteer alstublieft',
            empty: 'Geen gegevens'
        },
        input: {
            placeholder: 'Voer alstublieft in'
        },
        datePicker: {
            ...enConfig.datePicker,
            placeholder: {
                ...enConfig.datePicker.placeholder,
                date: ['Begindatum', 'Einddatum']
            },
            months: ['Jan', 'Feb', 'Maa', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
            weekdays: ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo']
        },
        pagination: {
            ...enConfig.pagination,
            itemsPerPage: "{size} / per pagina",
            jumpTo: "Spring naar",
            total: "{total} stuks"
        }
      })
      break
    case LOCALE.IT:
      customConfig = Object.assign(JSON.parse(JSON.stringify(enConfig)), {
        select: {
            placeholder: "Seleziona un'opzione",
            empty: 'Nessun risultato'
        },
        treeSelect: {
            placeholder: "Seleziona un'opzione",
            empty: 'Nessun risultato'
        },
        cascader: {
            placeholder: "Seleziona un'opzione",
            empty: 'Nessun risultato'
        },
        input: {
            placeholder: 'Inserisci...'
        },
        datePicker: {
            ...enConfig.datePicker,
            placeholder: {
                ...enConfig.datePicker.placeholder,
                date: ['Data di inizio', 'Data di fine']
            },
            months: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
            weekdays: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"]
        },
        pagination: {
            ...enConfig.pagination,
            itemsPerPage: "{size} / pagina",
            jumpTo: "Vai a",
            total: "{total} elementi"
        }
      })
      break
    default:
      customConfig = enConfig
  }

  return customConfig
}

export const getSystemConfig = () => {
  console.log('import.meta.env.MODE', import.meta.env)
  const config = {
    isElectron: window.electron ? true : false,
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    isMock: import.meta.env.MODE === 'mock',
    baseUrl: import.meta.env.VITE_PUBLIC_PATH || '',
    apiUrl: import.meta.env.VITE_GLOB_API_URL as string,
    locale: getGlobalLocale()
    // localeConfig: getTDesignLocale()
  }
  return config
}
